import { render, staticRenderFns } from "./odiv-xsd2.vue?vue&type=template&id=22169296&scoped=true&"
import script from "./odiv-xsd2.vue?vue&type=script&lang=js&"
export * from "./odiv-xsd2.vue?vue&type=script&lang=js&"
import style0 from "./odiv-xsd2.vue?vue&type=style&index=0&id=22169296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22169296",
  null
  
)

export default component.exports